import {Pipe, PipeTransform} from '@angular/core';
import {round} from 'lodash';

@Pipe({name: 'round'})
export class RoundNumberPipe implements PipeTransform {
    transform(value: number, precision: number = 0): number {
        return round(value, precision);
    }
}